import { ReactNode } from 'react';

export function EffectWrapper(props: {
  children: ReactNode;
  onClick?: Function;
  effect: 'redish' | 'orangish' | 'greenish' | 'blueish';
  bgColor: string;
  extensions?: string;
}) {
  const { children, effect, bgColor, extensions, onClick } = props;

  const HOVER_EFFECT = {
    redish: 'hover:bg-[#85000026]',
    orangish: 'hover:bg-[#9e530026]',
    blueish: 'hover:bg-[#1326ff26]',
    greenish: 'hover:bg-[#009e2f26] ',
  };
  return (
    <div
      className={`cursor-pointer effect-container bg-[${bgColor}] ${
        HOVER_EFFECT[effect]
      } ${extensions && extensions}`}
      onClick={() => onClick && onClick()}
    >
      {children}
    </div>
  );
}
